import { ONE, ZERO } from '@/constants/common';
import { store } from '@/redux/store';
import {
  closeDrawer,
  openBioEntityDrawerById,
  openCommentDrawerById,
  openDrawer,
  openOverlaysDrawer,
  openReactionDrawerById,
} from '@/redux/drawer/drawer.slice';
import type {
  BioEntityPanelData,
  CommentPanelData,
  DeprecatedDrawerName,
  DrawerName,
  ReactionPanelData,
} from 'minerva-plugin-api';
import { openLegend } from '@/services/pluginsManager/legend/openLegend';

type DataLessPanelName = Exclude<DrawerName, 'reaction' | 'bio-entity' | 'comment'>;

type OpenPanelArgs =
  | [panelName: DataLessPanelName]
  | [panelName: 'reaction', data: ReactionPanelData]
  | [panelName: 'bio-entity', data: BioEntityPanelData]
  | [panelName: 'comment', data: CommentPanelData]
  | [panelName: DrawerName | DeprecatedDrawerName];

export function openPanel(panelName: DataLessPanelName): void;
export function openPanel(panelName: 'reaction', data: ReactionPanelData): void;
export function openPanel(panelName: 'bio-entity', data: BioEntityPanelData): void;
export function openPanel(panelName: 'comment', data: CommentPanelData): void;
/** @deprecated kept so that v21 calls, including ones passing a name held in a variable, keep working */
export function openPanel(panelName: DrawerName | DeprecatedDrawerName): void;
export function openPanel(...args: OpenPanelArgs): void {
  const { dispatch } = store;
  const panelName = args[ZERO];

  switch (panelName) {
    case 'reaction':
      // the deprecated single-argument overload leaves the panel empty
      if (args[ONE]) dispatch(openReactionDrawerById(args[ONE].reactionId));
      else dispatch(openDrawer(panelName));
      break;
    case 'bio-entity':
      if (args[ONE]) dispatch(openBioEntityDrawerById(args[ONE].elementId));
      else dispatch(openDrawer(panelName));
      break;
    case 'comment':
      if (args[ONE]) dispatch(openCommentDrawerById(args[ONE].commentId));
      else dispatch(openDrawer(panelName));
      break;
    /** closing the drawer does not reset the overlays step, so open the list explicitly */
    case 'overlays':
      dispatch(openOverlaysDrawer());
      break;
    /** the legend is an overlay rather than a drawer panel, v21 routed it through openPanel */
    case 'legend':
      openLegend();
      break;
    /** a redux sentinel in v21, duplicating the undefined that already means "closed" */
    case 'none':
      dispatch(closeDrawer());
      break;
    /** an alias of 'available-plugins', v21 accepted both names for the plugins panel */
    case 'plugins':
      dispatch(openDrawer('available-plugins'));
      break;
    default:
      dispatch(openDrawer(panelName));
  }
}
